<div class="h-full w-full flex flex-col justify-start items-center overflow-hidden">
    @if (modelsWithBriefs() && modelsWithBriefs()!.length > 0) {
    <div class="h-full w-full flex flex-col items-center justify-start overflow-y-auto scrollbar-transparent space-y-2">
        @for (model of modelsWithBriefs(); track model.id) {
        <div
            class="w-full divide-y divide-zinc-200 overflow-hidden rounded-xl border border-zinc-200 bg-white shadow-sm dark:divide-zinc-800 dark:border-zinc-800 dark:bg-zinc-950 dark:shadow-none">
            <div class="px-4 py-2 flex flex-wrap items-center justify-between sm:flex-nowrap">
                <div class="flex-1 flex items-center">
                    <div class="">
                        <h3 class="text-base font-semibold text-primary">{{ model.title }}</h3>
                        <p class="text-sm text-secondary">
                            {{ model.createdDate | date:'dd/MM/yyyy' }}
                        </p>
                    </div>
                </div>
                <div class="shrink-0 flex flex-row items-center justify-end gap-x-2">
                    <span
                        class="inline-flex items-center rounded-md bg-primary/10 px-2 py-1 text-xs font-medium text-accent ring-1 ring-inset ring-primary/20 dark:bg-primary/15 dark:ring-primary/25">{{
                        model.briefs.length }} {{ model.briefs.length > 1 ? 'Briefs' : 'Brief' }}</span>
                    <button type="button" (click)="toggleExpandedModel(model.id)"
                        class="fab-button-secondary text-secondary shrink-0"
                        [attr.aria-expanded]="expandedModelId().includes(model.id)"
                        aria-label="Toggle briefs list for this pricing model">
                        @if (expandedModelId().includes(model.id)) {
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5">
                            <path d="m18 15-6-6-6 6" />
                        </svg>
                        } @else {
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5">
                            <path d="m6 9 6 6 6-6" />
                        </svg>
                        }
                    </button>
                </div>
            </div>
            @if (expandedModelId().includes(model.id)) {
            <div class="px-4 py-5 sm:p-6">
                @if (model.briefs.length > 0) {
                <div class="flow-root">
                    <div class="overflow-x-auto">
                        <div class="inline-block min-w-full align-middle">
                            <table class="min-w-full divide-y divide-gray-300 dark:divide-gray-700">
                                <thead class="bg-zinc-50 dark:bg-zinc-900/50">
                                    <tr>
                                        <th scope="col"
                                            class="py-3.5 pr-3 pl-4 text-left text-sm font-semibold text-primary sm:pl-0">
                                            Brief</th>
                                        <th scope="col"
                                            class="px-3 py-3.5 text-left text-sm font-semibold text-primary">
                                            Applications</th>
                                        <th scope="col"
                                            class="px-3 py-3.5 text-left text-sm font-semibold text-primary">
                                            Status</th>
                                        <th scope="col" class="relative py-3.5 pr-4 pl-3 sm:pr-0">
                                            <span class="sr-only">Edit</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody class="divide-y divide-gray-200 bg-white dark:divide-gray-700 dark:bg-transparent">

                                    @for (brief of model.briefs; track $index) {
                                    <tr>
                                        <td class="py-5 pr-3 pl-4 text-sm whitespace-nowrap sm:pl-0">
                                            <div class="flex items-center">
                                                <div class="">
                                                    <div class="font-medium text-primary">{{ brief.title }}</div>
                                                    <div class="mt-1 text-secondary">{{ brief.createdDate | date: "dd MMM yyyy HH:mm" }}</div>
                                                </div>
                                            </div>
                                        </td>
                                        <td class="px-3 py-5 text-sm whitespace-nowrap text-secondary">
                                            <div class="grid grid-cols-3">
                                                <div class="col-span-1">All: <span class="font-medium text-primary">{{
                                                        brief.filterStats.All }}</span></div>
                                                <div class="col-span-1">Inv: <span class="font-medium text-primary">{{
                                                        brief.filterStats.Invited }}</span></div>
                                                <div class="col-span-1">App: <span class="font-medium text-primary">{{
                                                        brief.filterStats.Applied }}</span></div>
                                                <div class="col-span-1">Hir: <span class="font-medium text-primary">{{
                                                        brief.filterStats.Hired }}</span></div>
                                                <div class="col-span-1">Sta: <span class="font-medium text-primary">{{
                                                        brief.filterStats.Started }}</span></div>
                                                <div class="col-span-1">P'ing: <span
                                                        class="font-medium text-primary">{{
                                                        brief.filterStats.ReadyToPost }}</span></div>
                                                <div class="col-span-1">P'ed: <span class="font-medium text-primary">{{
                                                        brief.filterStats.Posted }}</span></div>
                                                <div class="col-span-1">Com: <span class="font-medium text-primary">{{
                                                        brief.filterStats.Completed }}</span></div>
                                                <div class="col-span-1">Pai: <span class="font-medium text-primary">{{
                                                        brief.filterStats.Paid }}</span></div>
                                            </div>
                                        </td>
                                        <td class="px-3 py-5 text-sm whitespace-nowrap text-secondary">
                                            <span
                                                class="inline-flex items-center gap-x-1.5 rounded-full px-2 py-1 text-xs font-medium ring-1 ring-inset"
                                                [class]="getActiveColour(brief)">
                                                <svg class="h-1.5 w-1.5" [class]="getActiveDotColour(brief)"
                                                    viewBox="0 0 6 6" aria-hidden="true">
                                                    <circle cx="3" cy="3" r="3" />
                                                </svg>
                                                {{ getStatus(brief) }}
                                            </span>
                                        </td>
                                        <td
                                            class="relative py-5 pr-4 pl-3 text-right text-sm font-medium whitespace-nowrap sm:pr-0">
                                            <a class="text-accent hover:text-accent-dark hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary">Edit<span class="sr-only">, {{ brief.title }}</span></a>
                                        </td>
                                    </tr>
                                    }
                                    <!-- More people... -->
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                }
            </div>
            }
        </div>
        }
    </div>
    } @else if (modelsWithBriefs() && modelsWithBriefs()!.length == 0) {
    <div class="h-full w-full flex flex-col items-center justify-center">
        <div class="text-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="mx-auto size-12 text-secondary" aria-hidden="true">
                <path d="M3 3v16a2 2 0 0 0 2 2h16" />
                <path
                    d="M7 11.207a.5.5 0 0 1 .146-.353l2-2a.5.5 0 0 1 .708 0l3.292 3.292a.5.5 0 0 0 .708 0l4.292-4.292a.5.5 0 0 1 .854.353V16a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1z" />
            </svg>
            <h3 class="mt-2 text-sm font-semibold text-primary">No Custom Pricing Models</h3>
            <p class="mt-1 text-sm text-secondary">This brand has no custom pricing models yet.</p>
        </div>
    </div>
    } @else {
    <div class="h-full w-full flex flex-col items-center justify-center">
        <div class="text-center">
            <svg aria-hidden="true"
                class="mx-auto w-12 h-12 text-gray-200 animate-spin dark:text-gray-300 fill-primary"
                viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor" />
                <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill" />
            </svg>
            <h3 class="mt-2 text-sm font-semibold text-primary">Loading pricing models</h3>
            <p class="mt-1 text-sm text-secondary">Should be done in a moment.</p>
        </div>
    </div>
    }
</div>